export class OrderStateTransformer {
  static transform(obj) {
    return {
      id: obj.id,
      ...obj.attributes
    };
  }
}



// WEBPACK FOOTER //
// ./src/helpers/orders/orderState.transformer.js